module.exports = {
	"period": "2022 Q1–2023 Q4",
	"dataLabels": {
		"bc": {
			"12": {
				"AIDS: DTP Reports": 7,
				"AIDS: BCCDC Reports": 0
			},
			"1.2": {
				"Female": 3.5
			},
			"1.3": {
				"< 30": 3,
				"≥ 50": 0,
				"30–39": 10,
				"40–49": 0
			},
			"1.7": {
				"Fraser Health": 10
			},
			"2.1": {
				"Interior Health": 4,
				"Northern Health": 4
			},
			"2.2": {
				"Female": 5,
				"Male": 0
			},
			"2.3": {
				"< 30": 10
			},
			"3.3": {
				"< 30": 0,
				"≥ 50": 0,
				"30–39": 0,
				"40–49": 0
			},
			"3.4": {
				"MSM": 0,
				"NIR/Unknown": 5,
				"HET": 0,
				"PWID": 2,
				"Other": 0
			},
			"3.5": {
				"Interior Health": 0,
				"Vancouver Island Health": 0,
				"Fraser Health": 5,
				"Northern Health": -1
			},
			"6.1": {
				"No Baseline Genotype": 0,
				"<3 CD4 Tests": 5,
				"<3 Viral Load Tests": 10
			}
		},
		"fha": {
			"12": {
				"AIDS: DTP Reports": 20,
				"AIDS: BCCDC Reports": 0
			},
			"1.2": {
				"Female": 10
			},
			"1.3": {
				"< 30": 3,
				"≥ 50": 0,
				"30–39": 10,
				"40–49": 0
			},
			"1.5": {
				"Fraser North": 0
			},
			"1.6": {
				"Fraser North": -5
			},
			"1.7": {
				"Fraser North": 0
			},
			"2.1": {
				"Fraser South": 15
			},
			"2.2": {
				"Female": 13
			},
			"2.3": {
				"< 30": 5
			},
			"3.3": {
				"< 30": 0,
				"≥ 50": 12,
				"30–39": -12,
				"40–49": 0
			},
			"3.4": {
				"HET": 0,
				"NIR/Unknown": 0,
				"PWID": -3,
				"MSM": 0,
				"Other": 5
			},
			"3.5": {
				"Fraser South": 0,
				"Fraser North": 0,
				"Fraser East": 15
			},
			"6.1": {
				"<3 CD4 Tests": 5,
				"Non-Recommended ART": 0,
				"<3 Viral Load Tests": 15,
				"Baseline CD4 <200/µL": -10,
				"No Baseline Genotype": 3
			}
		},
		"iha": {
			"12": {
				"CD4<200 at ART Initiation": 0
			},
			"1.2": {
				"Male": 13,
				"Female": 0
			},
			"1.3": {
				"< 30": 0,
				"≥ 50": 0,
				"30–39": 7,
				"40–49": 0
			},
			"1.5": {
				"Kootenay Boundary": 0,
				"East Kootenay": 15
			},
			"1.6": {
				"Kootenay Boundary": 0,
				"East Kootenay": 15
			},
			"1.7": {
				"Kootenay Boundary": 0,
				"East Kootenay": 12
			},
			"2.1": {
				"Kootenay Boundary": 0,
				"Okanagan": 12,
				"Thompson Cariboo Shuswap": 12,
				"East Kootenay": 20
			},
			"2.2": {
				"Female": 2,
				"Male": 15
			},
			"2.3": {
				"≥ 50": 0,
				"< 30": 8
			},
			"3.2": {
				"Men": 0,
				"Women": 10
			},
			"3.3": {
				"< 30": 0,
				"≥ 50": 0,
				"30–39": 0,
				"40–49": 12
			},
			"3.4": {
				"Other": -6,
				"HET": 0,
				"PWID": -10,
				"MSM": 5,
				"NIR/Unknown": 0
			},
			"3.5": {
				"Thompson Cariboo Shuswap": 0,
				"East Kootenay": -12,
				"Okanagan": 0,
				"Kootenay Boundary": 12
			},
			"6.1": {
				"Non-Recommended ART": 15,
				"No Baseline Genotype": 0,
				"<3 Viral Load Tests": -12,
				"<3 CD4 Tests": 0,
				"Baseline CD4 <200/µL": -8
			}
		},
		"nha": {
			"7": {
				"Experienced Starts": 0,
				"First Starts": 0
			},
			"12": {
				"AIDS: BCCDC Reports": -10,
				"CD4<200 at ART Initiation": 20
			},
			"1.3": {
				"30–39": 5,
				"40–49": 0,
				"≥ 50": 10
			},
			"2.1": {
				"Northwest": 9
			},
			"2.3": {
				"≥ 50": 10
			},
			"3.2": {
				"Men": -20,
				"Women": -5
			},
			"3.3": {
				"30–39": -5,
				"40–49": -20,
				"< 30": 10,
				"≥ 50": -35
			},
			"3.4": {
				"HET": 0,
				"PWID": -8,
				"MSM": -20,
				"Other": 3,
				"NIR/Unknown": 0
			},
			"3.5": {
				"Northeast": -5,
				"Northwest": 10,
				"Northern Interior": -20
			},
			"6.1": {
				"<3 CD4 Tests": 15,
				"Non Viral Suppression at 9 Mo.": 0,
				"Baseline CD4 <200/µL": 0,
				"<3 Viral Load Tests": -15,
				"No Baseline Genotype": 0
			}
		},
		"vcha": {
			"12": {
				"AIDS: BCCDC Reports": 0,
				"AIDS: DTP Reports": 0
			},
			"1.3": {
				"< 30": 13
			},
			"1.5": {
				"North Shore / Coast Garibaldi": 8,
				"Richmond": 0
			},
			"1.6": {
				"North Shore / Coast Garibaldi": 5,
				"Richmond": 0
			},
			"1.7": {
				"North Shore / Coast Garibaldi": 12,
				"Richmond": 0
			},
			"2.3": {
				"40–49": 0,
				"≥ 50": 10
			},
			"3.3": {
				"30–39": 10,
				"< 30": -3,
				"40–49": 0
			},
			"3.4": {
				"NIR/Unknown": 5,
				"PWID": 10,
				"MSM": 5,
				"HET": -2,
				"Other": 10
			},
			"3.5": {
				"Richmond": 10
			},
			"6.1": {
				"Non-Recommended ART": 0,
				"No Baseline Genotype": 10,
				"<3 CD4 Tests": 5,
				"<3 Viral Load Tests": 10
			}
		},
		"viha": {
			"12": {
				"AIDS: BCCDC Reports": 0,
				"AIDS: DTP Reports": 3,
				"CD4<200 at ART Initiation": 3
			},
			"1.2": {
				"Male": 15
			},
			"1.3": {
				"< 30": 5
			},
			"2.1": {
				"South Vancouver Island": 10
			},
			"3.3": {
				"< 30": -10,
				"≥ 50": 15,
				"40–49": 0,
				"30–39": 2
			},
			"3.4": {
				"MSM": 0,
				"HET": 10,
				"PWID": -10,
				"Other": 12,
				"NIR/Unknown": 0
			},
			"3.5": {
				"South Vancouver Island": -10,
				"North Vancouver Island": 5
			},
			"6.1": {
				"Non-Recommended ART": 5,
				"No Baseline Genotype": 5,
				"<3 Viral Load Tests": -5
			}
		}
	},
	"breaks": {
		"bc": [
			{
				"from": 1300,
				"to": 7000,
				"breakSize": 500,
				"position": -230
			}
		],
		"fha": [
			{
				"from": 250,
				"to": 1700,
				"breakSize": 100,
				"position": -201
			}
		],
		"iha": [
			{
				"from": 90,
				"to": 440,
				"breakSize": 80,
				"position": -230
			}
		],
		"nha": [
			{
				"from": 50,
				"to": 200,
				"breakSize": 20,
				"position": -240
			}
		],
		"vcha": [
			{
				"from": 800,
				"to": 3900,
				"breakSize": 400,
				"position": -250
			}
		],
		"viha": [
			{
				"from": 140,
				"to": 800,
				"breakSize": 100,
				"position": -230
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./static/report.json
// module id = 11
// module chunks = 0